import { mapActions, mapState } from 'vuex';

export default {
  props: {
    placeholder: {
      type: String,
      default: '&nbsp;',
    },
    value: {
      default: null,
    },
    selected: Boolean,
    symbol: Boolean,
  },
  data() {
    return {
      double: false,
    };
  },
  computed: {
    ...mapState('trade', ['keyboardDoubleSelected']),
    number() {
      return parseInt(this.value, 10);
    },
    text() {
      return this.number > 0 ? this.number : this.placeholder;
    },
    selectedModifier() {
      return {
        'keyboard-numeric-input--double': this.selected && this.keyboardDoubleSelected && this.value !== null,
        'keyboard-numeric-input--selected': this.selected,
        'keyboard-numeric-input--empty': this.value === null,
      };
    },

  },
  methods: {
    ...mapActions('trade', ['updateKeyboardDoubleSelected']),
    click() {
      this.updateKeyboardDoubleSelected(!this.selected || !this.keyboardDoubleSelected);
      this.$emit('click');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/keyboard-numeric-input/keyboard-numeric-input.js